export default __webpack_public_path__ + "static/media/washupStampPromotionBanner.de86fa84.png";